export function getGoogleMapStreetViewUrl(lat: number, lng: number): string {
  const params = new URLSearchParams({
    layer: 'c',
    q: '',
    cbll: `${lat},${lng}`,
  });

  return `https://www.google.com/maps/?${params.toString()}`;
}
